import { ProgramContext } from '@rhg/providers/program';
import { useContext } from 'react';

/**
 * Uses context from the closest <ProgramProvider>
 * TODO: EVE-11111 throw error if used outside of ProgramProvider context (This may be difficult due to useTrackSessionEvent())
 */
export function useProvidedProgramContext() {
    const context = useContext(ProgramContext);
    return context;
}
